import React from 'react';
import { useTranslation } from 'react-i18next';
import CargomaticModal from 'components/v2/modal';
import LaneRateAudits from './LaneRateAudits';
export default ({ show, rate, onHide, type }) => {
    const { t } = useTranslation();
    return (React.createElement(CargomaticModal, { dataTestId: "CargomaticModal-7eea41c3", style: { top: '15%' }, dialogClassName: "rounded-xl border-2 border-green-cm w-full", showHeader: false, show: show, onHide: onHide, body: React.createElement("div", { "data-testid": "div-8d216754", className: "relative" },
            React.createElement("h2", { "data-testid": "h2-31e528f5", className: "text-xl bold m-0 mb-5" }, t('AUDIT_TRAIL')),
            React.createElement("div", { "data-testid": "div-a5fff0c5", className: "flex-auto" },
                React.createElement(LaneRateAudits, { rate: rate, type: type })),
            React.createElement("button", { "data-testid": "button-55b87c33", onClick: onHide, className: "absolute  bottom-2 right-4 button button-green" }, t('CLOSE').toUpperCase())) }));
};
